export default [
  {
    path: '/baseData',
    name: 'baseData',
    meta: {
      login: true
    }
  },
  { path: '/baseData/goodsManage', name: 'goodsManage', component: resolve => require(['@/views/baseData/goodsManage'], resolve)},
  { path: '/baseData/businessManagement', name: 'businessManagement', component: resolve => require(['@/views/baseData/businessManagement'], resolve)},
]



// WEBPACK FOOTER //
// ./src/config/router/baseData.js